{
  "name": "klubovna",
  "version": "2.0.7",
  "scripts": {
    "ng": "ng",
    "start": "ng serve --configuration default --port 4000",
    "start:dev": "ng serve --configuration dev --port 4000",
    "start:test": "ng serve --configuration test --port 4000",
    "start:prod": "ng serve --configuration production --port 4000",
    "build": "ng build",
    "prod": "ng build --configuration production",
    "dev": "ng build --configuration dev",
    "dev-test": "ng build --configuration test",
    "build:dev": "ng build --configuration dev",
    "build:test": "ng build --configuration test",
    "build:prod": "ng build --configuration production",
    "build:default": "ng build --configuration default",
    "generate:api": "ng-openapi-gen -c ng-openapi-gen.json",
    "format": "prettier --write \"src/**/*.{html,scss,css,json}\" \"public/**/*.{html,scss,css,json}\" && eslint \"src/**/*.ts\" --fix",
    "lint": "eslint \"src/**/*.ts\"",
    "lint:fix": "eslint \"src/**/*.ts\" --fix",
    "watch": "ng build --watch --configuration test",
    "test": "ng test",
    "test:e2e": "playwright test",
    "test:e2e:ui": "playwright test --ui",
    "test:e2e:headed": "playwright test --headed",
    "test:e2e:report": "playwright show-report",
    "serve:ssr:klubovna": "node dist/klubovna/server/server.mjs",
    "serve:ssr:dev": "npm run build:dev && npm run serve:ssr:klubovna",
    "serve:ssr:test": "npm run build:test && npm run serve:ssr:klubovna",
    "serve:ssr:prod": "npm run build:prod && npm run serve:ssr:klubovna",
    "serve:ssr": "npm run build:default && npm run serve:ssr:klubovna"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^21.0.0",
    "@angular/cdk": "^21.0.0",
    "@angular/common": "^21.0.0",
    "@angular/compiler": "^21.0.0",
    "@angular/core": "^21.0.0",
    "@angular/forms": "^21.0.0",
    "@angular/material": "^21.0.0",
    "@angular/platform-browser": "^21.0.0",
    "@angular/platform-browser-dynamic": "^21.0.0",
    "@angular/platform-server": "^21.0.0",
    "@angular/router": "^21.0.0",
    "@angular/service-worker": "^21.0.0",
    "@angular/ssr": "^21.0.0",
    "@ngrx/effects": "^21.0.1",
    "@ngrx/entity": "^21.0.1",
    "@ngrx/router-store": "^21.0.1",
    "@ngrx/store": "^21.0.1",
    "@ngrx/store-devtools": "^21.0.1",
    "@ngx-translate/core": "^17.0.0",
    "@ngx-translate/http-loader": "^17.0.0",
    "@sentry/angular": "^10.27.0",
    "bysquare": "^3.2.0",
    "chart.js": "^4.5.1",
    "express": "^5.1.0",
    "gsap": "^3.12.5",
    "ng2-charts": "^8.0.0",
    "ngx-image-cropper": "^7.0.6",
    "ngx-toastr": "^19.1.0",
    "qrcode": "^1.5.4",
    "rxjs": "~7.8.0",
    "swiper": "^12.0.3",
    "tslib": "^2.3.0"
  },
  "devDependencies": {
    "@angular-eslint/eslint-plugin": "^21.0.1",
    "@angular-eslint/template-parser": "^21.0.1",
    "@angular/build": "^21.0.0",
    "@angular/cli": "^21.0.0",
    "@angular/compiler-cli": "^21.0.0",
    "@eslint/js": "^9.39.1",
    "@playwright/test": "^1.58.1",
    "@types/express": "^5.0.1",
    "@types/jasmine": "^5.1.13",
    "@types/node": "^20.17.19",
    "@types/qrcode": "^1.5.6",
    "@typescript-eslint/eslint-plugin": "^8.48.0",
    "@typescript-eslint/parser": "^8.48.0",
    "autoprefixer": "^10.4.22",
    "eslint": "^9.39.1",
    "eslint-config-prettier": "^10.1.8",
    "jasmine-core": "^5.12.1",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "ng-openapi-gen": "^1.0.5",
    "postcss": "^8.4.49",
    "prettier": "^3.4.2",
    "tailwindcss": "^3.4.15",
    "typescript": "~5.9.3",
    "typescript-eslint": "^8.48.0"
  }
}
